import React from 'react';
import { toast } from 'react-toastify';
import api from "../api";

export function setSelectors(selectorsArray) {
  return	selectorsArray.map((item) => (
    <option key={item.id} value={item.id}>
      {item.name || item.title}
    </option>
  ));
}

export function setObjectiveSelector(selectorsArray) {
  return (
    Object.entries(selectorsArray).map((item) => (
      <option key={item[0]} value={item[0]}>
        {item[1]}
      </option>
    )));
}

export const showToastError = (message) => {
  toast.error(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 2500,
  });
};

// eslint-disable-next-line consistent-return
export function validateRequiredFields(...requiredFields) {
  const notFilledField = requiredFields.findIndex((item) => !item);
  if (notFilledField !== -1) {
	    showToastError('Fill in all required fields (marked with *)');
	    return true;
  }
}
export function setLeadData(
  subject,
  funnelTypeState,
  funnelStatus,
  priority,
  responsibleState,
  workTypes,
  workTech,
  comment,
  redmineLink,
  projectFolder,
  estimationFile,
) {
  return {
    title: subject,
    funnel_type: funnelTypeState,
    funnel_status: funnelStatus,
    priority,
    responsible: responsibleState,
    work_type: workTypes,
    work_technology: workTech,
    comment,
	  redmine_link: redmineLink,
	  estimation_file: estimationFile,
	  project_folder: projectFolder,
  };
}
export function setFiltersToStorage(cellName, data) {
  // console.log(data);
  localStorage.setItem(cellName, JSON.stringify(data));
}
export function setSearchToStorage(data, value) {
  sessionStorage.setItem('savedValue', value);
  sessionStorage.setItem('lastSearch', JSON.stringify(data));
  // console.log(value);
  if (value === '') {
    sessionStorage.removeItem('lastSearch');
  }
}
export function readAndParseFiltersFromStorage(cellName) {
  return JSON.parse(localStorage.getItem(cellName));
}
export function clearFiltersData(cellName) {
  localStorage.removeItem(cellName);
  //localStorage.setItem(cellName, JSON.stringify({ typed: 'sortByUpdated', title: 'Time updated: High to Low', order: 'desc' }))
  sessionStorage.removeItem('lastSearch');
  sessionStorage.removeItem('savedValue');
}
export function saveSortSelectTitle (sortTitle) {
  localStorage.removeItem('customSelectTrigger');
  localStorage.setItem('customSelectTrigger', sortTitle);
}

export function createPlanItem(data, redirect) {
  api.post('eventPlans', data).then(
    () => {
	    redirect('/plans-list');
    },
  );
}
